import { add } from './add';
import { boxPlot } from './boxPlot';
import { divide } from './divide';
import { findClosestIndex } from './findClosestIndex';
import { getTargetIndex } from './getTargetIndex';
import { multiply } from './multiply';
import { rotate } from './rotate';
import { subtract } from './subtract';

export const X = {
  add,
  boxPlot,
  divide,
  findClosestIndex,
  getTargetIndex,
  multiply,
  rotate,
  subtract,
};
